<ui-modal
  class="reports-modal"
  [isOpened]="showModal"
  [modalTitle]="modalTitle"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="reports-parameters-container">
    <div class="reports-parameters-container__parameters">
      <div class="reports-parameters-container__parameters__table">
        <form [formGroup]="parametersFormGroup">
          <div #divToScroll class="table-container">
            <table
              class="table-container__parameters"
              ui-table
              *ngIf="parameters.length"
            >
              <thead>
                <tr>
                  <th
                    [ngClass]="parameter.shortName"
                    *ngFor="let parameter of parameters"
                  >
                    {{ parameter.longName }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr tabindex="0">
                  <ng-container *ngFor="let parameter of parameters">
                    <ng-container [ngSwitch]="parameter.type">
                      <ng-container *ngSwitchCase="'dropdown'">
                        <td>
                          <ng-select
                            [items]="parameter.options"
                            [searchable]="true"
                            [id]="parameter.shortName"
                            class="input-cell"
                            [formControlName]="parameter.shortName"
                            appendTo="body"
                            [clearable]="true"
                          >
                          </ng-select>
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'number'">
                        <td>
                          <input
                            type="number"
                            [id]="parameter.shortName"
                            class="input-cell"
                            [formControlName]="parameter.shortName"
                          />
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'percent'">
                        <td>
                          <input
                            type="text"
                            [id]="parameter.shortName"
                            class="input-cell"
                            [formControlName]="parameter.shortName"
                            (click)="
                              textBoxCaretRestrictionHandler($event, 'click')
                            "
                            (keydown)="
                              textBoxCaretRestrictionHandler($event, 'keydown')
                            "
                            [inputValidator]="['percentageAllowNegatives']"
                          />
                        </td>
                      </ng-container>
                      <ng-container *ngSwitchCase="'date'">
                        <td class="hide-clr-error">
                          <clr-date-container>
                            <input
                              type="date"
                              clrDate
                              [id]="parameter.shortName"
                              [formControlName]="parameter.shortName"
                            />
                          </clr-date-container>
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'checkbox'">
                        <td id="checkbox">
                          <input
                            type="checkbox"
                            [id]="parameter.shortName"
                            [formControlName]="parameter.shortName"
                          />
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'text'">
                        <td>
                          <input
                            [placeholder]="parameter.placeHolder"
                            [id]="parameter.shortName"
                            class="input-cell"
                            [formControlName]="parameter.shortName"
                          />
                        </td>
                      </ng-container>

                      <ng-container *ngSwitchCase="'parameters'">
                        <td>
                          <button
                            class="input-cell__parameters-button"
                            [ngClass]="{
                              'parameter-not-valid': !formFieldValidity(
                                parameter.shortName
                              )
                            }"
                            (click)="openParametersModal(parameter.shortName)"
                          >
                            Parameters
                          </button>
                        </td></ng-container
                      >

                      <ng-container *ngSwitchCase="'multi-select'">
                        <td>
                          <ng-select
                            class="recipients"
                            [items]="parameter.options"
                            [multiple]="true"
                            [searchable]="true"
                            [closeOnSelect]="false"
                            [clearSearchOnAdd]="true"
                            [formControlName]="parameter.shortName"
                            [placeholder]="parameter.placeHolder"
                            appendTo="body"
                          >
                            <ng-template
                              ng-multi-label-tmp
                              let-items="items"
                              let-clear="clear"
                            >
                              <div class="ng-value" *ngIf="items.length > 0">
                                <span class="ng-value-label"
                                  >{{ items.length }}
                                  {{
                                    items.length > 1
                                      ? parameter.placeHolderMulti
                                      : parameter.placeHolderSingle
                                  }}</span
                                >
                              </div>
                            </ng-template>
                          </ng-select>
                        </td>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </tr>
              </tbody>
            </table>
            <div
              class="table-container__no-parameters"
              *ngIf="!parameters.length"
            >
              No parameters are required for this report
            </div>
          </div>
        </form>
      </div>
    </div>

    <div
      class="reports-parameters-container__output"
      *ngIf="outputFields?.length"
    >
      <div class="reports-parameters-container__output__table">
        <form [formGroup]="parametersFormGroup">
          <div #divToScroll class="table-container" formArrayName="output">
            <table class="table-container__parameters" ui-table>
              <thead>
                <tr>
                  <th id="type">Type</th>
                  <th id="underlying">Underlying</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  tabindex="0"
                  *ngFor="let item of outputFormArray; let i = index"
                  (click)="selectedReportParametersIndex = i"
                  [ngClass]="{
                    'selected-row': selectedReportParametersIndex === i
                  }"
                  [formArrayName]="i"
                >
                  <td>
                    <ng-select
                      [items]="typeOptions"
                      [searchable]="false"
                      [id]="'type'"
                      class="input-cell"
                      [formControlName]="'type'"
                      appendTo="body"
                      [clearable]="false"
                      (change)="typeChange(outputFormArray[i])"
                    >
                    </ng-select>
                  </td>

                  <td>
                    <ng-select
                      [items]="underlyingOptions"
                      [searchable]="false"
                      [id]="'underlining'"
                      class="input-cell"
                      [formControlName]="'underlying'"
                      [readonly]="underlyingOptionDisabled(outputFormArray[i])"
                      appendTo="body"
                      [clearable]="false"
                      (open)="setUnderlyingOutputOptions(outputFormArray[i])"
                    >
                    </ng-select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              class="table-container__no-parameters"
              *ngIf="!parameters.length"
            >
              No parameters are required for this report
            </div>
          </div>
        </form>
        <div class="bottom-table-add">
          <div *ngIf="!loadingReports; else reportsLoading">
            <span class="add-text-container">
              <label class="Page-1">+</label>
              <label class="add-text" (click)="addNewOutput()">
                Add Output
              </label>
            </span>
          </div>
          <ng-template #reportsLoading>
            <span class="add-text-container">
              <label class="add-text loading">Loading</label>
            </span>
          </ng-template>
        </div>
      </div>
      <div class="reports-parameters-container__output__footer">
        <button
          class="ui-button ui-button__header ui-button--danger ui-button--delete"
          [disabled]="selectedReportParametersIndex === null"
          (click)="deleteReportParametersOutput()"
        >
          Delete Output
        </button>
      </div>
    </div>
  </div>

  <app-schedule-reports-parameters
    *ngIf="showParameterSubModal"
    [parametersFormGroup]="parametersFormGroupForSubModal"
    [parameters]="parametersToViewOnSubModal"
    [showModal]="showParameterSubModal"
    [allCurrencyPairs]="allCurrencyPairs"
    (modalOpenStatusChanged)="parametersModalStatusChanged($event)"
    [modalTitle]="subModalTitle"
  ></app-schedule-reports-parameters>
</ui-modal>
